/* eslint-disable @stylistic/quote-props */
import type { BreadcrumbList, ListItem, WithContext } from 'schema-dts'

/**
 *
 * @param {Object} params
 * @param {{ text: string, link: string}[] | null} params.breadcrumb
 */

interface Params {
  breadcrumb?: { text: string, link: string }[] | null
}

export const useCommonJsonld = (params: Params) => {
  if (params.breadcrumb && params.breadcrumb.length > 0) {
    const breadcrumb: WithContext<BreadcrumbList> = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: params.breadcrumb.map((item, index) => {
        const listItem: ListItem = {
          '@type': 'ListItem',
          position: index + 1,
          name: item.text
        }
        if (item.link) {
          listItem.item = item.link
        }
        return listItem
      })
    }
    useJsonld(breadcrumb)
  }
}
